module.exports = __webpack_public_path__ + "img/manage-orders-hover.7e44bb20.svg";